<template>
  <div class="home mt-2">
    <div style="margin-bottom:10px; margin-left:20px">
      <a-breadcrumb>
        <a-breadcrumb-item href>
          <a-icon type="home"/>
        </a-breadcrumb-item>
        <a-breadcrumb-item href>
          <a-icon type="user"/>
          <span>User</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item>My Account</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <page-title :title="'My Account'" description="Manage and Edit your profile details"/>

    <div>
      <a-row>
        <div style="padding-left:20px; padding-top:20px">
          <h6 class="text-opacity">QUICK NAVIGATION</h6>
        </div>
        <a-col :span="7">
          <a-menu style="width: 256px" :defaultSelectedKeys="['1']" mode="inline">
            <a-sub-menu class="account-nav--left" key="sub1">
              <span slot="title">
                <a-icon type="solution"/>
                <span>Basic Information</span>
              </span>
            </a-sub-menu>
            <a-sub-menu class="account-nav--left" key="sub2">
              <span slot="title">
                <a-icon type="compass"/>
                <span>Location Information</span>
              </span>
            </a-sub-menu>
            <a-sub-menu class="account-nav--left" key="sub4">
              <span slot="title">
                <a-icon type="idcard"/>
                <span>Access Controls (Roles)</span>
              </span>
              <a-menu-item key="9">Option 9</a-menu-item>
            </a-sub-menu>
          </a-menu>
        </a-col>

        <a-col :span="17">
          <a-card>
            <div v-if="$route.name === 'account-show'">
              <router-link :to="{name: 'account-edit'}" style="color:black">
                <button class="btn-fixed">
                  <a-icon type="edit" class="pr-1" style="padding-right:3px"/>Edit Profile
                </button>
              </router-link>
            </div>
            <div v-else>
              <router-link :to="{name: 'account-show'}" style="color:black">
                <button class="btn-fixed">
                  <a-icon type="edit" class="pr-1" style="padding-right:3px"/>Cancel Edit
                </button>
              </router-link>
            </div>
            <router-view></router-view>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>


<script>
import PageTitle from "@/components/Headers/PageTitle";
export default {
  components: { PageTitle },
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$auth.user();
    }
  },
  mounted() {
    //this.$message.loading("Saving your Entry - One minute Please..", 0);
  }
};
</script>
